import Style from "./UserDetailsStyle";
import Spinner from "../../shared/Spinner/Spinner";
import { PhoneMask, CPFMask, CEPMask, CNPJMask } from "../../utils";
import { CurrentUserState, UserDetailsData } from "./Users";
import api from "../../services/api";
import { useContext, useEffect, useState } from "react";
import AuthContext from "../../contexts/authContext";
import { useStateIfMounted } from "use-state-if-mounted";
import PageTitle from "../../components/PageTitle";
import ReturnButton from "../../components/Buttons/ReturnButton";

export default function UserDetails(props) {
  const { LogOut } = useContext(AuthContext);
  const [loadingData, setLoadingData] = useStateIfMounted(false);
  const [user, setUser] = useStateIfMounted({} as UserDetailsData);
  const [apartments, setApartments] = useState([] as any);
  const { userData } = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState("");
  const [syncing, setSyncing] = useState(false);
  // const hasItems = selectedUser.orderItems.length > 0 && selectedUser.orderItems[0].id != null;

  const userId = props.match.params.userId;

  useEffect(() => {
    LoadUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function LoadUserData() {
    try {
      setLoadingData(true);
      const request = await api.get(`/users/${userId}`);
      const userData = request.data.userData;
      setLoadingData(false);
      setUser(userData);
      setApartments(userData.apartments);
    } catch (error: any) {
      if (error?.response?.status === 401) {
        LogOut();
        console.error("Não esta logado!");
        return;
      }
      console.error("Erro pegando dados");
      setLoadingData(false);
    }
  }

  function HasOrderItems() {
    return user.orderItems && user.orderItems.length > 0;
  }

  function FormatAddress({
    countryCode,
    zipCode,
    state,
    city,
    neighborhood,
    address,
    addressNumber,
    extendedAddress,
    specialAddress,
  }) {
    let addressFormatted = "";
    if (address) addressFormatted += address;
    if (address && addressNumber) addressFormatted += ", ";
    if (addressNumber) addressFormatted += addressNumber;
    if (addressNumber && extendedAddress) addressFormatted += " - ";
    if (extendedAddress) addressFormatted += extendedAddress;
    if ((extendedAddress || addressNumber) && specialAddress)
      addressFormatted += ", ";
    if (specialAddress) addressFormatted += specialAddress;
    if ((extendedAddress || addressNumber || specialAddress) && neighborhood)
      addressFormatted += " - ";
    if (neighborhood) addressFormatted += neighborhood;
    if (neighborhood && city) addressFormatted += ", ";
    if (city) addressFormatted += city;
    if (state) addressFormatted += " - ";
    if (state && zipCode) addressFormatted += ", ";
    if (zipCode) addressFormatted += CEPMask(zipCode);

    if (countryCode) {
      if (countryCode === "BR") addressFormatted += ", Brasil";
    }
    return addressFormatted;
  }

  async function ForceSync() {
    console.debug("Sincronizando usuário: ", user);
    setSyncing(true);

    try {
      const request = await api.post(`/sienge/bills/fromRemote/${userId}`);
      setSyncing(false);
      if (!request.data.success) {
        setErrorMessage(
          `Erro forçando sincronismo com Sienge: ${request.data.message}`
        );
        return;
      }
    } catch (error: any) {
      if (error.response.status === 422)
        setErrorMessage(`Usuário sem dados no Sienge`);
      else {
        setErrorMessage(`Erro forçando sincronismo com Sienge: ${error}`);
        console.error(error);
      }
      setSyncing(false);
    }
  }

  function MessageUser(userId: number) {
    props.history.push(`/messages/${userId}`);
  }

  function EditUser(userId: number) {
    props.history.push(`/users/${userId}/edit`);
  }
  function goToJournal() {
    props.history.push(`/users/${userId}/journal`);
  }

  function goToApartment(apartmentId: number) {
    props.history.push(`/enterprises/blocks/apartment/${apartmentId}`);
  }

  return (
    <Style className="default-page">
      <PageTitle title="Detalhes do Usuário" />
      <Spinner spinning={loadingData || syncing} />
      {errorMessage !== "" && <h1 className="alert"> {errorMessage}</h1>}
      <ReturnButton history={props.history} />
      <main className="default-main">
        <div className="userInfo panel">
          <section className="headerInfo">
            <h1>{user.name}</h1>
            <button
              className="btn btn-secondary"
              onClick={() => MessageUser(userId)}
            >
              Enviar mensagem
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => EditUser(userId)}
            >
              Editar usuário
            </button>
            <button
              className="btn btn-secondary"
              onClick={goToJournal}
            >
              Jornal
            </button>

            {/* TODO: Gambi: Verificar se a empresa tem sincronismo com sienge */}
            {userData.companyId === 8 && (
              <button id="externalSync" onClick={ForceSync}>
                Forçar sincronismo
              </button>
            )}
            {CurrentUserState(user)}
          </section>

          <form className="main-form">
            <h2 className="sectionLabel">Informações de Contato</h2>

            <div>
              <label>Id conta: </label>
              <span>{user.accountId}</span>
            </div>
            <div>
              <label>Id usuário: </label>
              <span>{user.userId}</span>
            </div>

            <label>Email: </label>
            {user.email}
            {user.cpf && (
              <div>
                <label>CPF: </label>
                <span>{CPFMask(user.cpf)}</span>
              </div>
            )}
            <div>
              <label>RG: </label>
              <span>{user.rg}</span>
            </div>
            {user.cnpj && (
              <div>
                <label>CNPJ: </label>
                <span>{CNPJMask(user.cnpj)}</span>
              </div>
            )}

            <div>
              <label>Telefone: </label>
              <span>{PhoneMask(user.phone)}</span>
            </div>

            {user.address && (
              <div>
                <label>Endereço: </label>
                <span>{FormatAddress(user)}</span>
              </div>
            )}
          </form>
        </div>

        {/* <div className="panel user-actions">
          <p className="test">Aqui vai ficar as ações do usuário
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus in urna iaculis dolor facilisis tempus. Donec nisi nibh, scelerisque ut dapibus in, mattis sed elit. Nulla neque tellus, aliquam sit amet est nec, maximus lobortis metus. Etiam rutrum tristique est non tempor. Vivamus sit amet diam in ipsum blandit blandit. Duis non dui nec lacus semper facilisis. Donec hendrerit nibh ut mauris facilisis aliquet. Ut ut placerat libero, eget faucibus metus. Proin vehicula dui nulla, a porttitor mauris consectetur nec. Aenean eget pretium purus. Aenean pharetra sagittis erat, ut ultricies ex maximus non.
          </p>
        </div> */}

        {HasOrderItems() && (
          <div className="panel">
            <section className="table-title">
              <h2>Produtos Escolhidos</h2>
            </section>
            <table className="table table-striped table-bordered table-hover main-table">
              <thead>
                <tr>
                  <th>Pedido</th>
                  <th>Produtos</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                {HasOrderItems() &&
                  user.orderItems.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.orderId}</td>
                        <td>{`${item.name}:`}</td>
                        <td>
                          {(item.price / 100).toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
        {apartments.length > 0 && (
          <div className="panel">
            <section className="table-title">
              <h2>Apartamentos</h2>
            </section>
            <table className="table table-striped table-bordered table-hover main-table">
              <thead>
                <tr>
                  <th>Empreendimento</th>
                  <th>Bloco</th>
                  <th>Andar</th>
                  <th>Apartamento</th>
                </tr>
              </thead>
              <tbody>
                {apartments.map((apartment) => {
                  return (
                    <tr key={apartment.id} onClick={() => goToApartment(apartment.apartmentId)}>
                      <td>{apartment.enterpriseName}</td>
                      <td>{apartment.blockName}</td>
                      <td>{apartment.floor + 1 + "º"}</td>
                      <td>{apartment.apartmentNumber}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </Style>
  );
}
